import styled from "styled-components";

export const VideoContainer = styled("div") <{
  isMobile?: boolean;
  isVertical?: boolean;
  isPreview?: boolean;
}>`
  width: 100%;
  max-width: 100%;
  height: auto;
  background: #000;
  border-radius: 8px;
  overflow: hidden;

  iframe {
    width: 100% !important;
    height: 100% !important;
    display: block;
  }
`;

export const LoadingText = styled.p`
  font-style: italic;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #000000;
  color: #ffffff;
  padding: 40px 20px;
  border-radius: 8px;
  height: 100%;
  text-align: center;
  min-height: 200px;
`;

export const LoadingMessage = styled.span`
  font-style: italic;
  font-size: 16px;
  line-height: 1.5;
  max-width: 400px;
`;

export const InLineContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
`;

